import type { Epic } from 'Flux/index.js'
import { orderSlice } from 'Flux/Slice/Order/OrderSlice.js'
import { authenticationExpiredOr } from 'Framework/Epic/AuthenticationExpired.js'
import { catchError, filter, mergeMap, of, switchMap } from 'rxjs'
import type { AjaxError } from 'rxjs/ajax'
import { isNotFoundError } from '../../../View/Component/scopeNotFound.ts'

export const GetOrderEpic: Epic = (action$, state$, { [orderSlice.name]: order, OrderRepository }) =>
  action$.pipe(
    filter(order.getOrderRequest.match),
    // The store holds one order: an answer for an order asked about before the latest must not land.
    switchMap((action) => {
      return OrderRepository.getOrder(action.payload.orderId).pipe(
        mergeMap((response) => of(order.getOrderRequestSuccess(response))),
        catchError((error: AjaxError) =>
          authenticationExpiredOr({
            error,
            failedRequest: action.type,
            failureAction: of(order.getOrderRequestFailure({ error, orderId: action.payload.orderId, notFound: isNotFoundError(error) }))
          })
        )
      )
    })
  )
